import {useState} from "preact/compat";

export const useRatingSlider = () => {
    // State to store the currently hovered option
    const [hoveredOption, setHoveredOption] = useState(null);

    // Procedure to handle the "hoveredOption" state
    const handleMouseEvent = (props) => {
        // Destructured props
        const {
            action,
            value
        } = props;

        // Actually assigns the value to the "hoveredOptions" state
        setHoveredOption(action === "ENTER" ? value : null);
    }

    return {
        hoveredOption,
        handleMouseEvent
    }
}
